import { Section } from '../components/Section/Section'
import { Metric } from '../components/Metric/Metric'
import { useAnalyticsContext } from '../AnalyticsContext'

export const ProfileInteractions = () => {
  const { period } = useAnalyticsContext()

  return (
    <Section title="Profile Interactions">
      <Metric name="Page Views" metricName="page_views" period={period} tooltip="Times your page has been viewed" />
      <Metric
        name="Website Clicks"
        metricName="page_clicks"
        period={period}
        tooltip="Total clicks on links to your website"
      />
    </Section>
  )
}
